import styled from "styled-components";
import { darken } from "polished";

const PageSubNavigationHeader = styled.div`
    padding: .75rem 1rem 0 1rem;
    background-color: ${props => darken(0.07, props.theme.light)};
    //border-bottom: 1px solid ${props => darken(0.15, props.theme.light)};
`;

export default PageSubNavigationHeader;